<template>
  <div class="error">
    <img class="error-icon" src="@img/error.png" />
    <p class="error-info">{{ info }}</p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      info: ''
    }
  },
  created: function () {
    this.info = this.$router.history.current.query.info
  }
}
</script>

<style lang="scss" scoped>
@use "@css/style.scss";
.error {
  background-color: #f9f9f9;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-icon {
    width: 103px;
    height: 103px;
    margin-top: 121px;
  }

  &-info {
    color: #323233;
    font-size: 18px;
    font-weight: 500;
    margin-top: 23px;
  }
}
</style>
